import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WsNoticias, IWsNoticias } from '@ciptech/classes';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class WsNoticiasService {
	endpoint = `/api`;

	constructor(private http: HttpClient) { }

	get(tag?: string): Observable<WsNoticias[]> {
		return this.http.get<IWsNoticias[]>(`${this.endpoint}/wsNoticias?tag=${tag || ''}`)
			.pipe(
				map((res: IWsNoticias[]) => res.map(item => new WsNoticias(item)))
			);
	}

	getByID(id: number): Observable<{ detail: WsNoticias, trending: WsNoticias[] }> {
		return this.http.get<any>(`${this.endpoint}/wsNoticias/detail/${id}`, { headers: { context: '.detail-notice' } })
			.pipe(
				map((res: any) => {
					return {
						detail: new WsNoticias(res.detail),
						trending: res.trending.map(item => new WsNoticias(item))
					};
				})
			);
	}

	getTrending(): Observable<WsNoticias[]> {
		return this.http.get<IWsNoticias[]>(`${this.endpoint}/wsNoticias/trending`)
			.pipe(
				map((res: IWsNoticias[]) => res.map(item => new WsNoticias(item)))
			);
	}

	insert(wsNoticia: WsNoticias): Observable<number> {
		const ws: any = { ...wsNoticia };

		ws.Tags = ws.sTags;
		delete ws.sTags;

		return this.http.post<number>(`${this.endpoint}/wsNoticias`, ws, { headers: { context: 'body' } });
	}

	delete(wsNoticia: WsNoticias): Observable<boolean> {
		return this.http.delete<boolean>(`${this.endpoint}/wsNoticias/${wsNoticia.IdNoticia}`, { headers: { context: 'body' } });
	}

}
